import styled from "styled-components";
import { SubgridColumn } from "../store/types";
import { Grid } from "src/elements";
import { SubgridFooter } from "./SubgridFooter";

const Foot = styled(Grid)`
  grid-column: 1 / -1;
  grid-template-columns: subgrid;
  position: sticky;
  bottom: 0;
  z-index: 1;
`;

interface Props<T> {
  columns: SubgridColumn<T>[];
}

export const SubgridFoot = <T,>({ columns }: Props<T>) => (
  <Foot>
    {columns.map((column, i) => (
      <SubgridFooter key={i} column={column} isLeftBorder={i === 0} />
    ))}
  </Foot>
);
